import { v4 } from 'uuid';

export const makeSocketID = (): string => v4();
